export const COLUMNS_NODE_NAME = 'columns';
export const COLUMN_NODE_NAME = 'column';
